module.exports = __webpack_public_path__ + "media/images/home/cover-mobile@2x-53f87d5dfac4fd26022f40ac16d10726.jpg";